<template>
  <div>
    <v-dialog v-model="dialog" width="1200">
      <v-card min-height="400">
        <v-card-text>
          <v-toolbar flat color="white">
            <v-toolbar-title v-if="customer !=null">{{customer}} {{$t('contacts_crud.contacts')}}</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <contact-create v-if="customer != null" ref="contactCreate" :customer="customer" @contactCreated="initialize" />
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="contacts"
            :pagination.sync="pagination"
            :rows-per-page-text="$t('contacts_crud.per_page')"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          > 
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.mobile }}</td>
              <td>
                <v-switch v-model="props.item.notify" @change="changeNotifications(props.item)"></v-switch>
              </td>
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" v-tooltip="$t('contacts_crud.edit')" @click="editItem(props.item)">edit</v-icon>
                <v-icon small v-tooltip="$t('contacts_crud.delete') " @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="warning" icon="warning">{{$t('contacts_crud.no_data')}}</v-alert>
              <v-btn color="primary">{{$t('contacts_crud.reset')}}</v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ContactCreate from "@/components/admin/contacts/ContactCreator.vue";
import Customer from "@/models/Customer.js";
import Contact from "@/models/Contact.js";
export default {
  name: "contacts-list",
  data() {
    return {
      dialog: false,
      customer: null,
      pagination: {
        rowsPerPage: 20
      },
      headers: [
        { text: this.$t("contacts_crud.name"), align: "left", value: "name" },
        { text: this.$t("contacts_crud.email"), value: "email" },
        { text: this.$t("contacts_crud.mobile"), value: "mobile" },
        { text: this.$t("contacts_crud.notify"), value: "notify" },
        {
          text: this.$t("contacts_crud.actions"),
          value: "name",
          sortable: false
        }
      ],
      rowsPerPageItems: [
        10,
        20,
        50,
        { text: this.$t("contacts_crud.all"), value: -1 }
      ],
      contacts: []
    };
  },

  methods: {
    async initialize() {
      const customer = await Customer.loadCustomer(this.customer.id);
      this.contacts = customer.contacts;
      this.dialog = true;
    },

    openAndPrepare(customer){
      this.customer = customer;
      this.contacts = customer.contacts;
      this.dialog = true;
    },

    /**
     * quick action to change notification settings
     * @param contact
     */
    changeNotifications(contact) {
      this.contactObj.updateContact(contact.id, {
        notify: contact.notify
      });
    },

    /**
     * uses external component
     * @param contact
     */
    editItem(contact) {
      this.$refs.contactCreate.loadContact(contact);
    },

    /**
     * deletes contact and refreshes contacts list
     * @param contact
     */
    async deleteItem(contact) {
      const confirmed = confirm(this.$t('contacts_crud.confirm_delete') + " " + contact.name + "?");
      if(!confirmed) return 0;
      const deleteContact = new Contact(contact);
      await deleteContact.delete();
      this.initialize();
    }
  },
  components: {
    ContactCreate
  }
};
</script>

